import React, { useCallback, useEffect, useRef, useState } from "react";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import {
	BookmarkIcon,
	CheckCircleIcon,
	ChevronLeftIcon,
	ChevronRightIcon,
} from "@heroicons/react/24/solid";
import { useSelector } from "react-redux";
import services from "utils/services";
import dayjs, { Dayjs } from "dayjs";
import Input from "shared/Input/Input";

import Select from "shared/Select/Select";
import { Shift } from "data/data";
// import { saveFilters } from "redux/reducers/auth";
import toast from "react-hot-toast";
import {
	avatarColors,
	DAY_DISPLAY,
	MONTH_DISPLAY,
	WEEK_DISPLAY,
} from "contains/contants";

import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import customParseFormat from "dayjs/plugin/customParseFormat"; // ES 2015
import weekOfYear from "dayjs/plugin/weekOfYear";
import updateLocale from "dayjs/plugin/updateLocale";
import NotifyPlanningSaved from "components/NotifyPlanningSaved";
import { Tooltip } from "react-tooltip";

import "dayjs/locale/fr";

import { PencilIcon, XMarkIcon } from "@heroicons/react/24/outline";
import ModalAlert from "components/ModalAlert";
import ModalUpdateDay from "components/ModalUpdateDay";
import { useAuth } from "provider/useAuth";
import { useSearchParams } from "react-router-dom";
import { Link } from "react-router-dom";
import Loading from "components/Loading";
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(customParseFormat);
dayjs.extend(weekOfYear);
dayjs.locale("fr");
dayjs.extend(updateLocale);

dayjs.updateLocale("fr", {
	weekStart: 1,
});

function PageHome() {
	const authContext = useAuth();

	const [searchParams] = useSearchParams();
	const queryDay = searchParams.get("day");

	const auth = useSelector((state: any) => state.auth);
	const today = useRef(dayjs().startOf("month"));
	const [displayType, setDisplayType] = useState(
		queryDay ? DAY_DISPLAY.value : MONTH_DISPLAY.value
	);
	const [displayDate, setDisplayDate] = useState(
		queryDay || dayjs().format("YYYY-MM-DD")
	);

	const [planning, setPlanning] = useState<any>([]);
	const [dateFrom, setDateFrom] = useState<Dayjs>(
		auth.filters?.dateTo ||
			(!!queryDay && dayjs(queryDay)) ||
			today.current.startOf("month")
	);
	const [dateTo, setDateTo] = useState<Dayjs>(
		auth.filters?.dateTo ||
			(!!queryDay && dayjs(queryDay)) ||
			today.current.endOf("month")
	);
	const [shifts, setShifts] = useState<Shift[]>([]);
	const [employees, setEmployees] = useState<any>([]);
	const [dayList, setDayList] = useState<any[]>([]);
	const [showAlert, setShowAlert] = useState(false);
	const [editMode, setEditMode] = useState(false);
	const [showDayEditModal, setShowDayEditModal] = useState(false);
	const [dayToEdit, setDayToEdit] = useState<any>(null);
	const [loading, setLoading] = useState<any>(true);

	useEffect(() => {
		getShifts();
		getEmployees();

		// if(queryDay){

		// getPlanning("", "");
		// }else{

		// }
	}, []);

	const getEmployees = () => {
		services.getUsers(
			{ enabled: 1 },
			(res) => {
				setEmployees(
					res.users.sort((a: any, b: any) => (a.pole < b.pole ? 1 : -1))
				);
			},
			(err) => {
				console.error(err);
			}
		);
	};

	const getShifts = () => {
		services.getShifts(
			{},
			(res) => {
				const shifts = res.shifts;
				shifts
					.filter((s: any) => !s.color)
					.forEach((s: any, ind: number) => (s.color = avatarColors[ind]));
				setShifts(shifts);
			},
			(err) => {
				console.error(err);
			}
		);
	};

	const cancelEdit = () => {
		setEditMode(false);

		getPlanning(dateFrom.format("YYYY-MM-DD"), dateTo.format("YYYY-MM-DD"));
	};
	const onSavePlanning = (status = "PENDING") => {
		setShowAlert(false);
		planning.status = status;
		planning.startDate = dateFrom.format("YYYY-MM-DD");
		planning.endDate = dateTo.format("YYYY-MM-DD");
		services.savePlanning(
			planning,
			(res) => {
				console.log("planning saved");
				toast.custom((t) => <NotifyPlanningSaved show={t.visible} />, {
					position: "top-center",
					id: "nc-planning-saved",
					duration: 3000,
				});
				setPlanning(res.planning);
				setEditMode(false);
			},
			(err) => {
				console.log("error on saving planning");
			}
		);
	};

	const onUpdateDay = (day: any) => {
		const empPlanning = planning.schedule?.find((s: any) => {
			return s.employee == day.employee;
		});
		const findDate = empPlanning.scheduleDays.find(
			(d: any) => d.dayDate == day.dayDate
		);

		findDate.timeSlots = [...day.timeSlots];
		findDate.isDayOff = day.timeSlots.length === 0;
		findDate.dayOffType = day.dayOffType;
		findDate.isRemoteWorking = day.isRemoteWorking;
		findDate.isModified = true;

		setPlanning({ ...planning });

		if (
			(planning && planning.status == "VALIDATED") ||
			displayType === WEEK_DISPLAY.value
		) {
			services.updateDayPlanning(
				day,
				(res) => {
					// console.log("planning saved");
					console.log("onUpdateDay", day);
					setShowDayEditModal(false);
					setDayToEdit(null);
					displayType === WEEK_DISPLAY.value &&
						getPlanning(
							dateFrom.format("YYYY-MM-DD"),
							dateTo.format("YYYY-MM-DD")
						);

					// toast.custom((t) => <NotifyPlanningSaved show={t.visible} />, {
					// 	position: "top-center",
					// 	id: "nc-planning-saved",
					// 	duration: 3000,
					// });
					// setPlanning(res.planning);
				},
				(err) => {
					console.log("error on saving planning");
				}
			);
		} else {
			setShowDayEditModal(false);
			setDayToEdit(null);
		}
	};

	// useEffect(() => {
	// 	updateFilters();
	// }, [
	// 	selectedDimension,
	// 	selectedSupport,
	// 	dateTo,
	// 	dateFrom,
	// 	search,
	// 	selectedPayment,
	// 	selectedProductType,
	// ]);

	// const updateFilters = () => {
	// 	dispatch(
	// 		saveFilters({
	// 			filters: {
	// 				selectedDimension,
	// 				selectedSupport,
	// 				dateFrom,
	// 				dateTo,
	// 				search,
	// 				selectedPayment,
	// 				selectedProductType,
	// 				selectedOption,
	// 				selectedGallery,
	// 			},
	// 		})
	// 	);
	// };

	const getPlanning = (dateFrom: string = "", dateTo: string = "") => {
		// updateFilters();
		services.getPlanning(
			{
				dateFrom,
				dateTo,
				displayType,
			},
			(success) => {
				setPlanning(success.planning);
				setLoading(false);
			},
			(error) => {
				console.error(error);
			}
		);
	};
	const onChangePeriod = useCallback(() => {
		let dateFrom, dateTo;
		if (displayType == MONTH_DISPLAY.value) {
			dateFrom = today.current.startOf("month");
			dateTo = today.current.endOf("month");
		} else if (displayType == WEEK_DISPLAY.value) {
			dateFrom = today.current.startOf("week");
			dateTo = today.current.endOf("week");
		} else {
			dateFrom = dayjs(displayDate);
			dateTo = dayjs(displayDate);
		}

		let tmpDate = dayjs(dateFrom, "DD/MM/YYYY");

		const days: any = {};
		while (tmpDate.isSameOrBefore(dateTo)) {
			const kWeek = tmpDate.year() + "-" + tmpDate.week();
			if (!days[kWeek]) {
				days[kWeek] = [];
			}
			days[kWeek].push({
				label:
					displayType == MONTH_DISPLAY.value
						? tmpDate.format("dd").charAt(0) + " " + tmpDate.format("DD")
						: tmpDate.format("dddd DD"),
				isSunday: tmpDate.day() === 0,
				isMonday: tmpDate.day() === 1,
				week: tmpDate.week() + "",
				date: tmpDate.format("YYYY-MM-DD"),
			});
			//console.log(dayjsDateFrom.format("DD/MM/YYYY"));
			tmpDate = tmpDate.add(1, "day");
		}

		setDayList(days);
		setDateFrom(dateFrom);
		setDateTo(dateTo);

		getPlanning(dateFrom.format("YYYY-MM-DD"), dateTo.format("YYYY-MM-DD"));
	}, [displayType]);

	useEffect(() => {
		if (displayType == MONTH_DISPLAY.value) {
			today.current = today.current.startOf("month");
		} else if (displayType == WEEK_DISPLAY.value) {
			today.current = dayjs();
		}

		onChangePeriod();
	}, [displayType, onChangePeriod]);

	useEffect(() => {
		if (displayType == DAY_DISPLAY.value) {
			onChangePeriod();
		}
	}, [displayDate, onChangePeriod]);

	// useEffect(() => {

	// }, [dateFrom, dateTo]);

	const nextPeriod = () => {
		if (displayType == MONTH_DISPLAY.value) {
			today.current = today.current.add(1, "month");
		} else {
			today.current = today.current.add(1, "week");
		}

		onChangePeriod();
	};

	const previousPeriod = () => {
		if (displayType == MONTH_DISPLAY.value) {
			today.current = today.current.subtract(1, "month");
		} else {
			today.current = today.current.subtract(1, "week");
		}

		onChangePeriod();
	};

	// const onDisplayDate = (date: string) => {
	// 	today.current = dayjs(date).startOf("month");
	// 	setDisplayDate(date);
	// 	setDisplayType(DAY_DISPLAY.value);
	// };
	const renderDaysHeader = (showDay = 1) => {
		const today = dayjs().format("YYYY-MM-DD");
		return Object.keys(dayList).map((w: any, index: number) =>
			dayList[w].map((d: any, indexD: number) => {
				return (
					<div
						key={indexD}
						// onClick={() => onDisplayDate(d.date)}
						style={{
							width: displayType == MONTH_DISPLAY.value ? "4%" : "auto",
						}}
						className={
							(displayType == MONTH_DISPLAY.value ? "" : "flex-1 ") +
							` cursor-pointer text-center py-1 text-sm ` +
							(indexD == dayList[w].length - 1 &&
							index == Object.keys(dayList).length - 1
								? ""
								: d.isSunday
								? "border-r-2"
								: "border-r") +
							(today == d.date ? " bg-warning font-bold !text-md" : "")
						}
					>
						<Link target="_blank" to={"?day=" + d.date}>
							{showDay ? d.label : ""}
						</Link>
					</div>
				);
			})
		);
	};

	const renderHoursHeader = () => {
		const hours = [];
		for (let i = 6; i < 22; i++) {
			hours.push(i);
		}

		return hours.map((hour: any, index: number) => {
			return (
				<div
					key={index}
					style={{
						width: 100 / hours.length + "%",
					}}
					className={
						"text-center py-1 text-sm " +
						(index == hours.length - 1 ? "" : "border-r")
					}
				>
					{(hour + "").padStart(2, "0")}
				</div>
			);
		});
	};

	const getContentTooltip = (day: any) => {
		return day
			? (displayType == MONTH_DISPLAY.value
					? dayjs(day.dayDate).format("ddd DD") + " : "
					: "") +
					(day.isDayOff || !day.timeSlots.length
						? day.dayOffType || "Repos"
						: day.timeSlots
								.map(
									(t: any, index: number) =>
										t.fromHour +
										"-" +
										t.toHour +
										(index < day.timeSlots.length - 1
											? displayType == MONTH_DISPLAY.value
												? " | "
												: " | "
											: "")
								)
								.join("") +
						  (day.isRemoteWorking == true ? " - Télétravail" : ""))
			: "";
	};

	const renderTimeslots = (scheduleDate: any) => {
		const currentShift = shifts.find(
			(sh: any) => sh.name == scheduleDate?.shiftName
		);
		return (
			<div className="relative w-full p-2">
				{scheduleDate ? (
					scheduleDate.isDayOff ? (
						<div
							style={{
								width: "99%",
								backgroundColor:
									scheduleDate.dayOffType && scheduleDate.dayOffType != "Repos"
										? "#dc3545"
										: "#ccc",
							}}
							className={`min-h-[100%] text-center font-semibold`}
						>
							{scheduleDate.dayOffType || "Repos"}
						</div>
					) : (
						scheduleDate.timeSlots.map((tSlot: any, index: number) => {
							const fromHourTab = tSlot.fromHour.split(":");
							const toHourTab = tSlot.toHour.split(":");

							const minutesFrom =
								fromHourTab[0] * 60 + parseInt(fromHourTab[1]);
							const minutesTo = toHourTab[0] * 60 + parseInt(toHourTab[1]);
							const diff = Math.abs(minutesTo - minutesFrom) / 60;
							const width = Math.round(diff * (100 / 16));
							const left = Math.round(
								((minutesFrom - 6 * 60) / 60) * (100 / 16)
							);

							return (
								<div
									style={{
										width: `${width}%`,
										top: "2px",
										left: left + "%",
										backgroundColor: currentShift?.color,
									}}
									key={index}
									className={`absolute bg-blue min-h-[100%] text-center text-sm`}
								>
									{tSlot.fromHour} - {tSlot.toHour}{" "}
									{scheduleDate.isRemoteWorking ? " - Télétravail" : ""}
								</div>
							);
						})
					)
				) : null}
			</div>
		);
	};

	const renderEmployeePlanning = (employee: any, index: number) => {
		let employeePlanning = planning.schedule?.find((s: any) => {
			return s.employee == employee._id;
		});

		if (!employeePlanning) {
			employeePlanning = {
				employee: employee._id,
				scheduleDays: [],
			};
			planning.schedule.push(employeePlanning);
		}

		const changePole = index > 0 && employee.pole != employees[index - 1].pole;

		return (
			<div key={index}>
				{(changePole || index === 0) && (
					<div
						className={`text-center w-[100%] border-t-2 border-b-4 border-neutral-500 border-l-none dark:border-slate-700 overflow-hidden z-0`}
					>
						<span className="text-lg font-bold">Pôle {employee.pole}</span>
					</div>
				)}
				<div
					className={`w-[100%] min-h-[${
						planning.status == "VALIDATED" ? "55px" : "80px"
					}] items-center flex flex-row flex-1 border-b-2 border-neutral-500 border-l-none border-t-none dark:border-slate-700 overflow-hidden z-0`}
				>
					<div className="text-sm font-semibold w-[10%] border-r pl-3">
						{employee.firstName} {employee.lastName?.charAt(0)}.
						<br />
						{displayType != WEEK_DISPLAY.value
							? (employeePlanning.totalHours || 0) + " h."
							: ""}
					</div>

					{/* <div className="flex flex-row w-[90%]">{renderDaysHeader(0)}</div> */}

					<div className="flex flex-row w-[90%] relative min-h-[20px]">
						{displayType == DAY_DISPLAY.value
							? renderTimeslots(
									employeePlanning?.scheduleDays.find((d: any) => {
										return (
											dayjs(d.dayDate).format("YYYY-MM-DD") === displayDate
										);
									})
							  )
							: Object.keys(dayList).map((kWeek: any, indexKd: number) => {
									const currWeek = kWeek.split("-")[1];
									const showShiftSelect =
										editMode &&
										displayType == MONTH_DISPLAY.value &&
										(!planning?.status || planning.status == "PENDING") &&
										dayList[kWeek][0].isMonday;
									const currentEmpShift = employeePlanning?.scheduleDays.find(
										(schDay: any) => schDay.week == currWeek
									);

									const currentShift = shifts.find(
										(sh: any) => sh.name == currentEmpShift?.shiftName
									);
									return (
										<div
											key={indexKd}
											className="flex flex-col relative"
											style={{
												width:
													displayType == MONTH_DISPLAY.value
														? dayList[kWeek].length * 4 + "%"
														: "100%",
											}}
										>
											<div className="flex flex-row min-h-[30px]">
												{dayList[kWeek].map((d: any, indexD: number) => {
													const existingDate =
														employeePlanning?.scheduleDays.find(
															(schDay: any) => {
																return dayjs(schDay.dayDate).isSame(
																	dayjs(d.date),
																	"date"
																);
															}
														);
													return (
														<div
															key={indexD}
															style={
																{
																	// width:
																	// 	displayType == MONTH_DISPLAY.value ? "4%" : "auto",
																	// backgroundColor: currentShift && currentShift.color,
																}
															}
															className={
																(displayType == MONTH_DISPLAY.value && 0
																	? ""
																	: "flex-1 ") +
																` text-center flex items-center ` +
																(indexD == dayList[kWeek].length - 1 &&
																indexKd == Object.keys(dayList).length - 1
																	? ""
																	: d.isSunday
																	? "border-r-2"
																	: "border-r")
															}
														>
															<div
																className={
																	"relative w-[80%] min-h-[35px] m-auto my-1 text-sm p-1 flex items-center justify-center rounded-md overflow-hidden " +
																	(existingDate &&
																	existingDate.isModified &&
																	existingDate.timeSlots.length > 0
																		? "before:content-[''] before:absolute before:m-[-15px] before:w-[30px] before:h-[30px] before:rotate-45  before:bg-slate-700 before:top-[0] before:left-[0]"
																		: "")
																}
																style={{
																	border:
																		existingDate && existingDate.isModified
																			? "0px solid #555"
																			: "",
																	backgroundColor:
																		existingDate &&
																		(existingDate.isDayOff ||
																			!existingDate.timeSlots.length)
																			? existingDate.dayOffType &&
																			  existingDate.dayOffType != "Repos"
																				? "#dc3545"
																				: "#ccc"
																			: currentShift && currentShift.color,
																}}
																data-tooltip-id="tooltip-hours"
																data-tooltip-html={
																	displayType == WEEK_DISPLAY.value
																		? ""
																		: getContentTooltip(existingDate)
																}
																onClick={() => {
																	if (editMode) {
																		setDayToEdit({
																			employee: employee._id,
																			...existingDate,
																		});
																		setShowDayEditModal(true);
																	}
																}}
															>
																{displayType == WEEK_DISPLAY.value &&
																	getContentTooltip(existingDate)}

																{displayType == MONTH_DISPLAY.value &&
																!!existingDate ? (
																	<span className="font-semibold">
																		{!!existingDate.dayOffType &&
																			existingDate.dayOffType != "Repos" &&
																			existingDate.dayOffType.charAt(0)}
																		{existingDate.isRemoteWorking == true &&
																			"T"}
																	</span>
																) : null}
															</div>
														</div>
													);
												})}
											</div>
											{/* {!!currentShift && !!currentShift.color && (
									<div className="flex flex-row absolute w-[100%] h-[55px] px-1 py-1 items-center justify-center">
										<div
											data-tooltip-id="tooltip-hours"
											data-tooltip-html={getContentTooltip(currentShift)}
											className="w-[100%] h-[100%]"
											style={{ backgroundColor: currentShift.color }}
										></div>
									</div>
								)} */}
											{!!showShiftSelect && (
												<div className=" flex flex-row w-[100%] py-2 items-center justify-center">
													<Select
														className={
															"!w-[80%] rounded-md shadow-lg border-slate-500"
														}
														value={currentShift ? currentShift.name : ""}
														onChange={({ target }) => {
															if (!employeePlanning) {
																planning.schedule.push({
																	employee,
																	scheduleDays: [],
																});
																employeePlanning = planning.schedule?.find(
																	(s: any) => s.employee == employee._id
																);
															}

															const shiftSelected: any = shifts.find(
																(s: any) => s.name == target.value
															);
															dayList[kWeek].forEach(
																(weekDay: any, indexDay: number) => {
																	const nScheduleDay = {
																		shiftName: shiftSelected
																			? shiftSelected.name
																			: "",
																		week: currWeek,
																		day: shiftSelected
																			? shiftSelected.schedule[indexDay].day
																			: "",
																		dayDate: weekDay.date,
																		timeSlots: shiftSelected
																			? [
																					...shiftSelected.schedule[indexDay]
																						.timeSlots,
																			  ]
																			: [],
																		isDayOff: shiftSelected
																			? shiftSelected.schedule[indexDay]
																					.isDayOff ||
																			  !shiftSelected.schedule[indexDay]
																					.timeSlots.length
																			: false,
																		// dayOffType: {
																		// 	type: String,
																		// 	enum: ["Repos", "Conges", "Maladie"],
																		// 	default: "",
																		// },
																	};
																	const existingIndex =
																		employeePlanning?.scheduleDays.findIndex(
																			(schDay: any) => {
																				return dayjs(schDay.dayDate).isSame(
																					dayjs(weekDay.date),
																					"day"
																				);
																			}
																		);
																	if (existingIndex !== -1) {
																		if (!shiftSelected) {
																			employeePlanning.scheduleDays.splice(
																				existingIndex,
																				1
																			);
																		} else {
																			employeePlanning.scheduleDays[
																				existingIndex
																			] = nScheduleDay;
																		}
																	} else {
																		employeePlanning.scheduleDays.push(
																			nScheduleDay
																		);
																	}
																}
															);

															setPlanning({ ...planning });
														}}
													>
														<option value=""></option>
														{shifts.map((shift: any, indexS: number) => (
															<option value={shift.name} key={indexS}>
																{shift.name}
															</option>
														))}
													</Select>
												</div>
											)}
										</div>
									);
							  })}
					</div>
				</div>
			</div>
		);
	};

	const renderButtons = () => {
		return (
			<div className="print:hidden flex flex-row gap-3">
				{planning.status != "VALIDATED" &&
				displayType === MONTH_DISPLAY.value ? (
					<div className="flex flex-row gap-3">
						{editMode ? (
							<>
								<ButtonPrimary
									className="rounded-xl p-2 !bg-red-200 !text-red-600 !border-danger border-[1px] hover:!bg-red-300"
									onClick={() => cancelEdit()}
								>
									<XMarkIcon className="w-5 h-5 mr-1" /> Annuler
								</ButtonPrimary>
								<ButtonPrimary
									className="rounded-xl p-2 !bg-slate-200 !text-black  hover:!bg-slate-300"
									onClick={() => onSavePlanning()}
								>
									<BookmarkIcon className="w-5 h-5 mr-1" /> Enregistrer
								</ButtonPrimary>{" "}
							</>
						) : (
							<ButtonPrimary
								className="rounded-xl p-2 !bg-slate-200 !text-black  hover:!bg-slate-300"
								onClick={() => setEditMode(true)}
							>
								<PencilIcon className="w-5 h-5 mr-1" /> Modifier
							</ButtonPrimary>
						)}
					</div>
				) : (
					planning.status === "VALIDATED" && (
						<div>
							<p className="font-semibold text-lg">
								<CheckCircleIcon className="w-6 h-6 inline text-success " />{" "}
								Planning validé
							</p>
						</div>
					)
				)}
			</div>
		);
	};
	return (
		<div className="nc-PageHome relative overflow-hidden">
			{/* SECTION HERO */}
			{/* <SectionHero2 /> */}

			<div className="container relative my-8 px-14">
				<div>
					<h2 className="text-2xl md:text-3xl font-semibold">Planning</h2>
				</div>
				<div className=" relative my-3">
					<BackgroundSection className="bg-neutral-50/80 dark:bg-black/20" />
					<div className="flex mt-2 justify-end items-start gap-2"></div>
					<div className="flex flex-col py-2 items-center relative">
						<div className="w-[100%]">
							<div className="flex flex-col gap-3 py-2 items-center">
								<div className="print:hidden flex flex-row gap-3 items-start w-[100%] justify-between">
									<div className="flex flex-row gap-3">
										<div
											className={`relative  h-10 sm:h-11  w-[120px]  rounded-2xl border flex items-center justify-center text-sm sm:text-base uppercase font-semibold select-none overflow-hidden z-0 cursor-pointer ${
												displayType == MONTH_DISPLAY.value
													? "bg-slate-900 text-white hover:!bg-slate-800"
													: "border-slate-300 dark:border-slate-600 text-slate-900 dark:text-slate-200 hover:bg-neutral-50 dark:hover:bg-neutral-700"
											}`}
											onClick={() => {
												setDisplayType(MONTH_DISPLAY.value);
											}}
										>
											{MONTH_DISPLAY.label}
										</div>
										<div
											className={`relative h-10 sm:h-11  w-[120px]  rounded-2xl border flex items-center justify-center text-sm sm:text-base uppercase font-semibold select-none overflow-hidden z-0 cursor-pointer ${
												displayType == WEEK_DISPLAY.value
													? "bg-slate-900 text-white hover:!bg-slate-800"
													: "border-slate-300 dark:border-slate-600 text-slate-900 dark:text-slate-200 hover:bg-neutral-50 dark:hover:bg-neutral-700"
											}`}
											onClick={() => {
												setDisplayType(WEEK_DISPLAY.value);
											}}
										>
											{WEEK_DISPLAY.label}
										</div>
										<div
											className={`relative h-10 sm:h-11  w-[120px]  rounded-2xl border flex items-center justify-center text-sm sm:text-base uppercase font-semibold select-none overflow-hidden z-0 cursor-pointer ${
												displayType == DAY_DISPLAY.value
													? "bg-slate-900 text-white hover:!bg-slate-800"
													: "border-slate-300 dark:border-slate-600 text-slate-900 dark:text-slate-200 hover:bg-neutral-50 dark:hover:bg-neutral-700"
											}`}
											onClick={() => {
												setDisplayType(DAY_DISPLAY.value);
											}}
										>
											{DAY_DISPLAY.label}
										</div>
									</div>
									{!!authContext.user &&
										authContext.user.role === "ADMIN" &&
										renderButtons()}
								</div>
								<div className="w-[100%] border-2 border-slate-500 rounded-lg min-h-80">
									<div className="flex flex-row items-center justify-between py-3 px-3 bg-white rounded-t-lg border-dashed border-slate-500 border-b-4 rounded-b-none">
										<span className="font-semibold text-lg flex-1 text-right">
											{DAY_DISPLAY.value == displayType
												? dayjs(displayDate).format("dddd DD MMMM")
												: today.current.format("MMMM YYYY")}
										</span>
										<div className="flex-1 text-right flex justify-end">
											{displayType === DAY_DISPLAY.value ? (
												<Input
													className="!w-[160px] rounded-md border-blue"
													type="date"
													value={displayDate}
													onChange={({ target }) => {
														setDisplayDate(target.value);
													}}
												/>
											) : (
												<span className="px-2 py-1 bg-slate-200 rounded-md flex flex-row gap-2 items-center">
													<ChevronLeftIcon
														className="w-6 h-6 cursor-pointer text-blue font-bold "
														onClick={() => previousPeriod()}
													/>
													<span className="font-semibold">
														{dateFrom.format("DD/MM/YYYY")} -{" "}
														{dateTo.format("DD/MM/YYYY")}
													</span>
													<ChevronRightIcon
														className="w-6 h-6 cursor-pointer text-blue"
														onClick={() => nextPeriod()}
													/>
												</span>
											)}
										</div>
									</div>
									<div className="flex flex-col">
										<div className="flex flex-row border-b-2">
											<div className="w-[10%] border-r"></div>
											<div className="flex flex-row w-[90%] items-center">
												{DAY_DISPLAY.value == displayType
													? renderHoursHeader()
													: renderDaysHeader()}
											</div>
										</div>
										{loading && (
											<div className="flex items-center justify-center h-[150px]">
												<Loading />
											</div>
										)}
										{!!planning &&
											!!planning.schedule &&
											employees
												.filter((employee: any) =>
													dayjs(employee.entryDate).isSameOrBefore(
														dateTo,
														"date"
													)
												)
												.map((employee: any, index: number) => {
													return renderEmployeePlanning(employee, index);
												})}
									</div>
								</div>
								{/* <div className="flex flex-col sm:flex-row gap-3 items-center">
									<div className="max-w-lg items-center">
										<Label className="text-neutral-800 text-sm">Entre: </Label>
										<div className="mt-1.5 flex">
											<span className="inline-flex items-center px-2.5 rounded-md !rounded-r-none border border-r-0 border-neutral-200 dark:border-neutral-700 bg-neutral-50 dark:bg-neutral-800 text-neutral-500 dark:text-neutral-400 text-sm">
												<i className="text-2xl las la-calendar"></i>
											</span>
											<Input
												className=" rounded-md !rounded-l-none"
												type="date"
												value={dateFrom}
												onChange={({ target }) => {
													setDateFrom(target.value);
												}}
											/>
										</div>
									</div>
									<div className="max-w-lg items-center">
										<Label className="text-neutral-800 text-sm">Et : </Label>
										<div className="mt-1.5 flex">
											<span className="inline-flex items-center px-2.5 rounded-md !rounded-r-none border border-r-0 border-neutral-200 dark:border-neutral-700 bg-neutral-50 dark:bg-neutral-800 text-neutral-500 dark:text-neutral-400 text-sm">
												<i className="text-2xl las la-calendar"></i>
											</span>
											<Input
												className="rounded-md !rounded-l-none"
												type="date"
												value={dateTo}
												onChange={({ target }) => {
													setDateTo(target.value);
												}}
											/>
										</div>
									</div>
								</div> */}
							</div>
						</div>
					</div>
				</div>
			</div>

			{showAlert && !!authContext.user && authContext.user.role === "ADMIN" && (
				<ModalAlert
					onCloseModal={() => setShowAlert(false)}
					onConfirm={() => onSavePlanning("VALIDATED")}
					confirmText="Oui"
					closeText="Non"
					title="VALIDER LE PLANNING"
					text="Êtes vous sûr de valider le planning pour ce mois ?"
					show={showAlert}
				/>
			)}

			{showDayEditModal &&
				!!dayToEdit &&
				!!authContext.user &&
				authContext.user.role === "ADMIN" && (
					<ModalUpdateDay
						show={showDayEditModal}
						onCloseModal={() => setShowDayEditModal(false)}
						day={dayToEdit}
						onConfirm={(updatedDay) => onUpdateDay(updatedDay)}
					/>
				)}
			<Tooltip id="tooltip-hours" place="bottom" />
		</div>
	);
}

export default PageHome;
